import { useSyncExternalStore } from "react";

const TOP_BUTTON_THRESHOLD = 200;

const getSnapshot = () => {
  if (typeof window === "undefined") {
    return false;
  }

  return window.scrollY >= TOP_BUTTON_THRESHOLD;
};

const getServerSnapshot = () => false;

const subscribe = (callback: () => void) => {
  if (typeof window === "undefined") {
    return (): void => undefined;
  }

  window.addEventListener("scroll", callback, { passive: true });

  return () => {
    window.removeEventListener("scroll", callback);
  };
};

export const useShouldShowScrollToTop = (): boolean => {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
